import React from 'react';
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";

import { compose } from 'recompose';
// @material-ui/core components
import { AuthUserContext, withAuthorization, withEmailVerification } from '../Session';
import Button from '@material-ui/core/Button'
// import BarcodeReader from 'react-barcode-reader'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography'

import AddBox from '@material-ui/icons/AddBox';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import FormControlLabel from '@material-ui/core/FormControlLabel'
import MaterialTable from "material-table";
import { Radio, RadioGroup, TextField } from '@material-ui/core';
// const { protobuf } = require('sawtooth-sdk');
// const { createHash } = require('crypto')

const tableIcons = {
  Add: AddBox,
  Check: Check,
  Clear: Clear,
  Delete: DeleteOutline,
  DetailPanel: ChevronRight,
  Edit: Edit,
  Export: SaveAlt,
  Filter: FilterList,
  FirstPage: FirstPage,
  LastPage: LastPage,
  NextPage: ChevronRight,
  PreviousPage: ChevronLeft,
  ResetSearch: Clear,
  Search: Search,
  SortArrow: ArrowUpward,
  ThirdStateCheck: Remove,
  ViewColumn: ViewColumn
};


class HomePage extends React.Component {

  state = {}
  constructor(props) {
    super(props);
    this.state = {
      header: "Home",
      result: 'No Result',
      value: "one",
      setValue: "one",
      assetSelected: '',
      prodType: '',
      quantity: '',
      strandValue: '',
      seedType: '',
      unit: '',
      tableData: [],
      strandListing: [],
      action: '',
      quant: '',
      plot: ''
    }
  }

  componentDidMount() {

    const authUser = JSON.parse(localStorage.getItem('authUser'));
    console.log(authUser)
    const data = { 'publicKey': authUser.publicKey }

    console.log(data)
    fetch("http://ec2-18-216-1-90.us-east-2.compute.amazonaws.com:5000/getAssetList", {
      method: 'POST',
      body: JSON.stringify(data)
    }).then(res => res.json())
      .then(res => {
        this.setState({ tableData: res })
      })


    fetch("http://ec2-18-216-1-90.us-east-2.compute.amazonaws.com:5000/getStrandList", {
      method: 'POST',
      body: JSON.stringify(data)
    }).then(res => res.json())
      .then(res => {
        console.log(res)
        this.setState({ strandListing: res })
      })
  }

  TabContainer(props) {
    return (
      <Typography component="div" style={{ padding: 8 * 3, textAlign: 'center' }}>
        {props.children}
      </Typography>
    );
  }

  handleScan(data) {
    console.log(data);
    this.setState({
      result: data
    })
  }

  handleError(err) {
    console.log(err)
  }

  handleChange(event, newValue) {
    this.setState({
      value: newValue
    })
  }

  selectStrand(rowData) {
    console.log(rowData)
    this.setState({
      assetSelected: rowData
    })
  }

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  productView() {
    // this.setState({action: action})

    if (this.state.action === 'GEN') {
      return (<div>
        <h4>Product View under Generate</h4>
      </div>)
    }
    if (this.state.action === 'CNV') {
      return this.ConvertSelected()
    }
    if (this.state.action === 'SHP') {
      return this.ShipSelected()
    }
    if (this.state.action === 'REC') {
      return this.Receive()
    }
    if (this.state.action === 'PLNT') {
      return this.PlantSelected()
    }
    if (this.state.action === 'HVST') {
      return this.HarvestSelected()
    }
    else {
      return (
        <div><Typography variant='h5'>Choose an option on the right panel</Typography></div>
      )
    }
  }

  strandView() {
    if (this.state.action === 'GEN') {
      return this.GenerateSelected()
    }
    if (this.state.action === 'CNV') {
      return (<div>
        <h4>Strand View under Convert</h4>
      </div>)
    }
    if (this.state.action === 'SHP') {
      return (<div>
        <h4>Strand View under Ship</h4>
      </div>)
    }
    if (this.state.action === 'REC') {
      return (<div>
        <h4>Strand View under Receive</h4>
      </div>)
    }
    if (this.state.action === 'PLNT') {
      return (<div>
        <h4>Strand View under Plant</h4>
      </div>)
    }
    if (this.state.action === 'HVST') {
      return (<div>
        <h4>Strand View under Harvest</h4>
      </div>)
    }
    else {
      return (
        <div><Typography variant='h5'>Choose an option on the right panel</Typography></div>
      )
    }
  }

  plotView() {
    if (this.state.action === 'GEN') {
      return (<div>
        <h4>Plot View under Generaet</h4>
      </div>)
    }
    if (this.state.action === 'CNV') {
      return (<div>
        <h4>Plot View under Convert</h4>
      </div>)
    }
    if (this.state.action === 'SHP') {
      return (<div>
        <h4>Plot View under Ship</h4>
      </div>)
    }
    if (this.state.action === 'REC') {
      return (<div>
        <h4>Plot View under Receive</h4>
      </div>)
    }
    if (this.state.action === 'PLNT') {
      return (<div>
        <h4>Plot View under Plant</h4>
      </div>)
    }
    if (this.state.action === 'HVST') {
      return (<div>
        <h4>Plot View under Harvest</h4>
      </div>)
    }
    else {
      return (
        <div><Typography variant='h5'>Choose an option on the right panel</Typography></div>
      )
    }
  }

  Generate() {
    this.setState({
      header: "Generate",
      value: 'two',
      action: 'GEN',
      assetSelected: '',
      prodType: '',
      quantity: '',
      strandValue: '',
      seedType: '',
      unit: '',
    })
  }

  GenerateSelected() {
    const { quantity, seedType, unit } = this.state;
    const isInvalid = quantity === '' || seedType === '' || unit === '';

    return (
      <div style={{
        marginLeft: '20%',
        marginRight: '20%',
      }}>
        <h3>You are Generating</h3>
        <h4>{this.state.assetSelected['producer']}|
        {this.state.assetSelected['strandType']}|
        {this.state.seedType}|
        {this.state.quantity}
        </h4>
        <form onSubmit={this.onGenerateSubmit}>
          <div style={{
            display: 'flex'
          }}>
            <div style={{
              width: '50%'
            }}>
              <h3 style={{
                textAlign: 'left'
              }}>Seed Type</h3>
              <RadioGroup
                aria-label="seedType"
                name="seedType"
                value={seedType}
                onChange={this.onChange}
              >
                <FormControlLabel value="seed" control={<Radio />} label="seed" />
                <FormControlLabel value="clone" control={<Radio />} label="clone" />
              </RadioGroup>

            </div>

            <div style={{
              width: '50%'
            }}>
            </div>
          </div>
          <h3>Quantity</h3>
          <TextField
            name="quantity"
            value={quantity}
            onChange={this.onChange}
            type="number"
            placeholder="Quantity"
            style={{ paddingBottom: '10px', textAlign: 'left' }}
          />
          <br></br>
          <TextField
            name="unit"
            value={unit}
            onChange={this.onChange}
            type="text"
            placeholder="Unit"
            style={{ paddingBottom: '10px', textAlign: 'left' }}
          />
          <br></br>
          <Button disabled={isInvalid} type="submit">
            Submit
            </Button>
        </form>
      </div>
    )

  }

  onGenerateSubmit = event => {
    const opType = "GEN";
    const prodID = "" + Math.floor(Math.random() * (10000));
    var date = new Date();
    const ts = "" + Math.floor(date.getTime() / 1000);
    console.log(ts);
    const authUser = JSON.parse(localStorage.getItem('authUser'));

    const info = this.state.assetSelected['producer'] + '\^' + this.state.assetSelected['strandType'] + '\^' +
      this.state.assetSelected['strandName'] + '\^' + this.state.quantity + '\^' + authUser.xplotLocation
      + '\^' + authUser.yplotLocation + '\^' + authUser.address

    var payload = opType + ',' + prodID + ',' + ts + ',' + info;
    console.log(payload)
    const data = {
      'payload': payload,
      'publicKey': authUser.publicKey,
      'privateKey': authUser.privateKey
    }

    fetch('http://ec2-18-216-1-90.us-east-2.compute.amazonaws.com:5000/transactionHeader', {
      method: 'POST',
      body: JSON.stringify(data),
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      },

    })
      .then(res => res.json())
      .then(res => console.log(res))
      .catch(e => console.log(e));

    event.preventDefault();
  }

  Convert() {
    this.setState({
      header: "Convert",
      value: 'one',
      action: "CNV",
      assetSelected: '',
      prodType: '',
      quantity: '',
      strandValue: '',
      seedType: '',
      unit: '',
    })
  }

  ConvertSelected() {
    if (this.state.assetSelected == '') {
      return (
        <div>
          <h4>Select an Asset</h4>
        </div>
      );
    }
    else {
      const { prodType, quantity, unit, quant } = this.state;
      const isInvalid = prodType === '' || quantity === '' || unit === '' || quant === '';

      return (
        <div style={{
          marginLeft: '20%',
          marginRight: '20%',
        }}>
          <h2>Selected {this.state.assetSelected.id}</h2>
          <form onSubmit={this.onConvertSubmit}>
            <div style={{
              display: 'flex'
            }}>
              <div style={{
                width: '50%'
              }}>
                <h3 style={{
                  textAlign: 'left'
                }}>Converting To</h3>
                <RadioGroup
                  aria-label="prodType"
                  name="prodType"
                  onChange={this.onChange}
                  value={prodType}
                >
                  <FormControlLabel value="fiber" control={<Radio />} label="fiber" />
                  <FormControlLabel value="grain" control={<Radio />} label="grain" />
                  <FormControlLabel value="hybrid" control={<Radio />} label="hybrid" />
                  <FormControlLabel value="extract" control={<Radio />} label="extract" />
                </RadioGroup>
              </div>
            </div>
            <br></br>
            <h3>Quantity</h3>
            <TextField
              name="quant"
              value={quant}
              onChange={this.onChange}
              type="text"
              placeholder="Amount Used"
              style={{ paddingBottom: '10px', textAlign: 'left' }}
            />
            <TextField
              name="quantity"
              value={quantity}
              onChange={this.onChange}
              type="number"
              placeholder="New Quantity"
              style={{ paddingBottom: '10px', textAlign: 'left' }}
            />
            <TextField
              name="unit"
              value={unit}
              onChange={this.onChange}
              type="text"
              placeholder="Unit"
              style={{ paddingBottom: '10px', textAlign: 'left' }}
            />
            <br></br>
            <Button disabled={isInvalid} type="submit">
              Submit
            </Button>
          </form>
          <h4>{this.state.seedType} {this.state.prodType} {this.state.strandValue} {this.state.quantity}</h4>
        </div>
      )
    }
  }

  onConvertSubmit = event => {
    const opType = "CNV";
    const prodID = "" + Math.floor(Math.random() * (10000));
    var date = new Date();
    const ts = "" + date.getTime();
    console.log(ts);
    const authUser = JSON.parse(localStorage.getItem('authUser'));

    const info = this.state.prodType + '\|' + this.state.quantity + '\|'
      + 'seed' + '\|'
      + authUser.company + '\|'
      + this.state.prodID + '\|' + this.state.quant;

    var payload = opType + ',' + prodID + ',' + ts + ',' + info;
    console.log(payload)
    const data = {
      'payload': payload,
      'publicKey': authUser.publicKey,
      'privateKey': authUser.privateKey
    }

    fetch('http://ec2-18-216-1-90.us-east-2.compute.amazonaws.com:5000/transactionHeader', {
      method: 'POST',
      body: JSON.stringify(data),
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      },

    })
      .then(res => res.json())
      .then(res => console.log(res))
      .catch(e => console.log(e));

    event.preventDefault();
  }

  Ship() {
    this.setState({
      header: "Ship",
      value: 'one',
      action: "SHP",
      assetSelected: '',
      prodType: '',
      quantity: '',
      strandValue: '',
      seedType: '',
      unit: '',
    })
  }

  ShipSelected() {
    if (this.state.assetSelected == null) {
      return (
        <div>
          <h4>Select an Asset</h4>
        </div>
      );
    }
    else {
      const { prodType, strandValue, quantity, seedType, unit } = this.state;
      const isInvalid = prodType === '' || strandValue === '' || quantity === '' || seedType === '' || unit === '';

      return (
        <div style={{
          marginLeft: '20%',
          marginRight: '20%',
        }}>
          <h2>Selected {this.state.assetSelected.id}</h2>
          <form onSubmit={this.onGenerateSubmit}>
            <div style={{
              display: 'flex'
            }}>
              <div style={{
                width: '50%'
              }}>
                <h3 style={{
                  textAlign: 'left'
                }}>Seed Type</h3>
                <RadioGroup
                  aria-label="seedType"
                  name="seedType"
                  value={seedType}
                  onChange={this.onChange}
                >
                  <FormControlLabel value="seed" control={<Radio />} label="seed" />
                  <FormControlLabel value="clone" control={<Radio />} label="clone" />
                </RadioGroup>

              </div>

              <div style={{
                width: '50%'
              }}>
                <h3 style={{
                  textAlign: 'left'
                }}>Product Type</h3>
                <RadioGroup
                  aria-label="prodType"
                  name="prodType"
                  onChange={this.onChange}
                  value={prodType}
                >
                  <FormControlLabel value="fiber" control={<Radio />} label="fiber" />
                  <FormControlLabel value="grain" control={<Radio />} label="grain" />
                  <FormControlLabel value="hybrid" control={<Radio />} label="hybrid" />
                  <FormControlLabel value="extract" control={<Radio />} label="extract" />
                </RadioGroup>
              </div>
            </div>
            <h3>Strand</h3>
            <TextField
              name="strandValue"
              value={strandValue}
              onChange={this.onChange}
              type="text"
              placeholder="Strand"
              style={{ paddingBottom: '10px', textAlign: 'left' }}
            />
            <br></br>
            <h3>Quantity</h3>
            <TextField
              name="quantity"
              value={quantity}
              onChange={this.onChange}
              type="number"
              placeholder="Quantity"
              style={{ paddingBottom: '10px', textAlign: 'left' }}
            />
            <TextField
              name="unit"
              value={unit}
              onChange={this.onChange}
              type="text"
              placeholder="Unit"
              style={{ paddingBottom: '10px', textAlign: 'left' }}
            />
            <br></br>
            <Button disabled={isInvalid} type="submit">
              Submit
            </Button>
          </form>
          <h4>{this.state.seedType} {this.state.prodType} {this.state.strandValue} {this.state.quantity}</h4>
        </div>
      )
    }
  }

  onShipSubmit = event => {
    const opType = "SHP";
    const prodID = "" + Math.floor(Math.random() * (10000));
    var date = new Date();
    const ts = "" + date.getTime();
    console.log(ts);
    const authUser = JSON.parse(localStorage.getItem('authUser'));

    const info = this.state.seedType + '\|' + this.state.prodType + '\|'
      + this.state.strandValue + '\|'
      + authUser.company + '\|'
      + this.state.quantity
    // + this.state.unit + '\|'

    var payload = opType + ',' + prodID + ',' + ts + ',' + info;
    console.log(payload)
    const data = {
      'payload': payload,
      'publicKey': authUser.publicKey,
      'privateKey': authUser.privateKey
    }

    fetch('http://ec2-18-216-1-90.us-east-2.compute.amazonaws.com:5000/transactionHeader', {
      method: 'POST',
      body: JSON.stringify(data),
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      },

    })
      .then(res => res.json())
      .then(res => console.log(res))
      .catch(e => console.log(e));

    // const transactionHeader = protobuf.TransactionHeader.encode({
    //   signerPublicKey: 'publicKey',
    //   familyName: 'TRACE',
    //   familyVersion: '0.1',
    //   inputs: ['cbd420'],
    //   outputs: ['cbd420'],
    //   dependencies: [],
    //   payloadSha512: createHash('sha512').update(payload).digest('hex'),
    //   batcherPublicKey: 'publicKey'
    // }).finish()

    // console.log(transactionHeader)

    event.preventDefault();
  }

  Receive() {
    this.setState({
      header: "Receive",
      value: 'one',
      action: "CNV",
      assetSelected: '',
      prodType: '',
      quantity: '',
      strandValue: '',
      seedType: '',
      unit: '',
    })
  }

  ReceiveSelected() {
    if (this.state.assetSelected == null) {
      return (
        <div>
          <h4>Select an Asset</h4>
        </div>
      );
    }
    else {
      const { prodType, strandValue, quantity, seedType, unit } = this.state;
      const isInvalid = prodType === '' || strandValue === '' || quantity === '' || seedType === '' || unit === '';

      return (
        <div style={{
          marginLeft: '20%',
          marginRight: '20%',
        }}>
          <h2>Selected {this.state.assetSelected.id}</h2>
          <form onSubmit={this.onGenerateSubmit}>
            <div style={{
              display: 'flex'
            }}>
              <div style={{
                width: '50%'
              }}>
                <h3 style={{
                  textAlign: 'left'
                }}>Seed Type</h3>
                <RadioGroup
                  aria-label="seedType"
                  name="seedType"
                  value={seedType}
                  onChange={this.onChange}
                >
                  <FormControlLabel value="seed" control={<Radio />} label="seed" />
                  <FormControlLabel value="clone" control={<Radio />} label="clone" />
                </RadioGroup>

              </div>

              <div style={{
                width: '50%'
              }}>
                <h3 style={{
                  textAlign: 'left'
                }}>Product Type</h3>
                <RadioGroup
                  aria-label="prodType"
                  name="prodType"
                  onChange={this.onChange}
                  value={prodType}
                >
                  <FormControlLabel value="fiber" control={<Radio />} label="fiber" />
                  <FormControlLabel value="grain" control={<Radio />} label="grain" />
                  <FormControlLabel value="hybrid" control={<Radio />} label="hybrid" />
                  <FormControlLabel value="extract" control={<Radio />} label="extract" />
                </RadioGroup>
              </div>
            </div>
            <h3>Strand</h3>
            <TextField
              name="strandValue"
              value={strandValue}
              onChange={this.onChange}
              type="text"
              placeholder="Strand"
              style={{ paddingBottom: '10px', textAlign: 'left' }}
            />
            <br></br>
            <h3>Quantity</h3>
            <TextField
              name="quantity"
              value={quantity}
              onChange={this.onChange}
              type="number"
              placeholder="Quantity"
              style={{ paddingBottom: '10px', textAlign: 'left' }}
            />
            <TextField
              name="unit"
              value={unit}
              onChange={this.onChange}
              type="text"
              placeholder="Unit"
              style={{ paddingBottom: '10px', textAlign: 'left' }}
            />
            <br></br>
            <Button disabled={isInvalid} type="submit">
              Submit
            </Button>
          </form>
          <h4>{this.state.seedType} {this.state.prodType} {this.state.strandValue} {this.state.quantity}</h4>
        </div>
      )
    }
  }

  onReceiveSubmit = event => {
    const opType = "REC";
    const prodID = "" + Math.floor(Math.random() * (10000));
    var date = new Date();
    const ts = "" + date.getTime();
    console.log(ts);
    const authUser = JSON.parse(localStorage.getItem('authUser'));

    const info = this.state.seedType + '\|' + this.state.prodType + '\|'
      + this.state.strandValue + '\|'
      + authUser.company + '\|'
      + this.state.quantity
    // + this.state.unit + '\|'

    var payload = opType + ',' + prodID + ',' + ts + ',' + info;
    console.log(payload)
    const data = {
      'payload': payload,
      'publicKey': authUser.publicKey,
      'privateKey': authUser.privateKey
    }

    fetch('http://ec2-18-216-1-90.us-east-2.compute.amazonaws.com:5000/transactionHeader', {
      method: 'POST',
      body: JSON.stringify(data),
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      },

    })
      .then(res => res.json())
      .then(res => console.log(res))
      .catch(e => console.log(e));

    event.preventDefault();
  }

  Plant() {
    this.setState({
      header: "Plant",
      value: 'three',
      action: "PLNT",
      assetSelected: '',
      prodType: '',
      quantity: '',
      strandValue: '',
      seedType: '',
      unit: '',
    })
  }

  PlantSelected() {
    if (this.state.assetSelected == '') {
      return (
        <div>
          <h4>Select an Asset</h4>
        </div>
      );
    }
    else {
      const authUser = JSON.parse(localStorage.getItem('authUser'));

      const { plot, quantity, unit } = this.state;
      const isInvalid = quantity === '' || quantity === '' || unit === '';

      return (
        <div style={{
          marginLeft: '20%',
          marginRight: '20%',
        }}>
          <h2>Selected {this.state.assetSelected.id}</h2>
          <form onSubmit={this.onGenerateSubmit}>
            <div style={{
              display: 'flex'
            }}>
              <div style={{
                width: '50%'
              }}>
                <h3 style={{
                  textAlign: 'left'
                }}>Plot</h3>
                <RadioGroup
                  aria-label="plot"
                  name="plot"
                  value={plot}
                  onChange={this.onChange}
                >
                  <FormControlLabel value="plot1" control={<Radio />} label={authUser.xplotLocation + ', ' + authUser.yplotLocation} />
                  <FormControlLabel value="other" control={<Radio />} label="Other" />
                </RadioGroup>

              </div>

              <div style={{
                width: '50%'
              }}>
                {/* <h3 style={{
                  textAlign: 'left'
                }}>Product Type</h3> */}
                {/* <RadioGroup
                  aria-label="prodType"
                  name="prodType"
                  onChange={this.onChange}
                  value={prodType}
                >
                  <FormControlLabel value="fiber" control={<Radio />} label="fiber" />
                  <FormControlLabel value="grain" control={<Radio />} label="grain" />
                  <FormControlLabel value="hybrid" control={<Radio />} label="hybrid" />
                  <FormControlLabel value="extract" control={<Radio />} label="extract" />
                </RadioGroup> */}
              </div>
            </div>
            {/* <h3>Strand</h3>
            <TextField
              name="strandValue"
              value={strandValue}
              onChange={this.onChange}
              type="text"
              placeholder="Strand"
              style={{ paddingBottom: '10px', textAlign: 'left' }}
            /> */}
            <br></br>
            <h3>Quantity</h3>
            <TextField
              name="quantity"
              value={quantity}
              onChange={this.onChange}
              type="number"
              placeholder="Quantity"
              style={{ paddingBottom: '10px', textAlign: 'left' }}
            />
            <TextField
              name="unit"
              value={unit}
              onChange={this.onChange}
              type="text"
              placeholder="Unit"
              style={{ paddingBottom: '10px', textAlign: 'left' }}
            />
            <br></br>
            <Button disabled={isInvalid} type="submit">
              Submit
            </Button>
          </form>
          {/* <h4>{this.state.seedType} {this.state.prodType} {this.state.strandValue} {this.state.quantity}</h4> */}
        </div>
      )
    }
  }

  onPlantSubmit = event => {
    const opType = "PLNT";
    const prodID = "" + Math.floor(Math.random() * (10000));
    var date = new Date();
    const ts = "" + date.getTime();
    console.log(ts);
    const authUser = JSON.parse(localStorage.getItem('authUser'));

    const info = this.state.seedType + '\|' + this.state.prodType + '\|'
      + this.state.strandValue + '\|'
      + authUser.company + '\|'
      + this.state.quantity
    // + this.state.unit + '\|'

    var payload = opType + ',' + prodID + ',' + ts + ',' + info;
    console.log(payload)
    const data = {
      'payload': payload,
      'publicKey': authUser.publicKey,
      'privateKey': authUser.privateKey
    }

    fetch('http://ec2-18-216-1-90.us-east-2.compute.amazonaws.com:5000/transactionHeader', {
      method: 'POST',
      body: JSON.stringify(data),
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      },

    })
      .then(res => res.json())
      .then(res => console.log(res))
      .catch(e => console.log(e));

    event.preventDefault();
  }

  Harvest() {
    this.setState({
      header: "Harvest",
      value: 'three',
      action: "HVST",
      assetSelected: '',
      prodType: '',
      quantity: '',
      strandValue: '',
      seedType: '',
      unit: '',
    })
  }

  HarvestSelected() {
    if (this.state.assetSelected == '') {
      return (
        <div>
          <h4>Select an Asset</h4>
        </div>
      );
    }
    else {
      const authUser = JSON.parse(localStorage.getItem('authUser'));

      const { plot, quantity, unit } = this.state;
      const isInvalid = quantity === '' || quantity === '' || unit === '';

      return (
        <div style={{
          marginLeft: '20%',
          marginRight: '20%',
        }}>
          <h2>Selected {this.state.assetSelected.id}</h2>
          <form onSubmit={this.onGenerateSubmit}>
            <div style={{
              display: 'flex'
            }}>
              <div style={{
                width: '50%'
              }}>
                <h3 style={{
                  textAlign: 'left'
                }}>Plot</h3>
                <RadioGroup
                  aria-label="plot"
                  name="plot"
                  value={plot}
                  onChange={this.onChange}
                >
                  <FormControlLabel value="plot1" control={<Radio />} label={authUser.xplotLocation + ', ' + authUser.yplotLocation} />
                  <FormControlLabel value="other" control={<Radio />} label="Other" />
                </RadioGroup>

              </div>

              <div style={{
                width: '50%'
              }}>
                {/* <h3 style={{
                  textAlign: 'left'
                }}>Product Type</h3> */}
                {/* <RadioGroup
                  aria-label="prodType"
                  name="prodType"
                  onChange={this.onChange}
                  value={prodType}
                >
                  <FormControlLabel value="fiber" control={<Radio />} label="fiber" />
                  <FormControlLabel value="grain" control={<Radio />} label="grain" />
                  <FormControlLabel value="hybrid" control={<Radio />} label="hybrid" />
                  <FormControlLabel value="extract" control={<Radio />} label="extract" />
                </RadioGroup> */}
              </div>
            </div>
            {/* <h3>Strand</h3>
            <TextField
              name="strandValue"
              value={strandValue}
              onChange={this.onChange}
              type="text"
              placeholder="Strand"
              style={{ paddingBottom: '10px', textAlign: 'left' }}
            /> */}
            <br></br>
            <h3>Quantity</h3>
            <TextField
              name="quantity"
              value={quantity}
              onChange={this.onChange}
              type="number"
              placeholder="Quantity"
              style={{ paddingBottom: '10px', textAlign: 'left' }}
            />
            <TextField
              name="unit"
              value={unit}
              onChange={this.onChange}
              type="text"
              placeholder="Unit"
              style={{ paddingBottom: '10px', textAlign: 'left' }}
            />
            <br></br>
            <Button disabled={isInvalid} type="submit">
              Submit
            </Button>
          </form>
          {/* <h4>{this.state.seedType} {this.state.prodType} {this.state.strandValue} {this.state.quantity}</h4> */}
        </div>
      )
    }
  }

  onHarvestSubmit = event => {
    const opType = "HVST";
    const prodID = "" + Math.floor(Math.random() * (10000));
    var date = new Date();
    const ts = "" + date.getTime();
    console.log(ts);
    const authUser = JSON.parse(localStorage.getItem('authUser'));

    const info = this.state.seedType + '\|' + this.state.prodType + '\|'
      + this.state.strandValue + '\|'
      + authUser.company + '\|'
      + this.state.quantity
    // + this.state.unit + '\|'

    var payload = opType + ',' + prodID + ',' + ts + ',' + info;
    console.log(payload)
    const data = {
      'payload': payload,
      'publicKey': authUser.publicKey,
      'privateKey': authUser.privateKey
    }

    fetch('http://ec2-18-216-1-90.us-east-2.compute.amazonaws.com:5000/transactionHeader', {
      method: 'POST',
      body: JSON.stringify(data),
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      },

    })
      .then(res => res.json())
      .then(res => console.log(res))
      .catch(e => console.log(e));

    // const transactionHeader = protobuf.TransactionHeader.encode({
    //   signerPublicKey: 'publicKey',
    //   familyName: 'TRACE',
    //   familyVersion: '0.1',
    //   inputs: ['cbd420'],
    //   outputs: ['cbd420'],
    //   dependencies: [],
    //   payloadSha512: createHash('sha512').update(payload).digest('hex'),
    //   batcherPublicKey: 'publicKey'
    // }).finish()

    // console.log(transactionHeader)

    event.preventDefault();
  }

  tableView() {
    if (this.state.action == 'GEN') {
      return (
        <MaterialTable
          columns={[
            { title: "Strand Producer", field: "producer" },
            { title: "Strand Name", field: "strandName" },
            { title: "Strand Type", field: "strandType" }
          ]}
          data={
            this.state.strandListing
          }
          actions={[
            {
              icon: 'expand_more',
              tooltip: 'Expand',
              onClick: (event, rowData) => this.selectStrand(rowData)
            }
          ]}
          title="Asset List"
        />
      )
    }
    else {
      return (
        <MaterialTable
          columns={[
            { title: "ID", field: "id" },
            { title: "Product Type", field: "pType" },
            { title: "Quantity", field: "qty", type: "numeric" },
            { title: "Units", field: "unit" },
            { title: "Status", field: "status" }
          ]}
          data={
            this.state.tableData
          }
          actions={[
            {
              icon: 'expand_more',
              tooltip: 'Expand',
              onClick: (event, rowData) => this.selectStrand(rowData)
            }
          ]}
          title="Asset List"
        />
      )
    }
  }

  render() {
    const { authUser, classes, color, children } = this.props;
    console.log(this.state.tableData)
    return (
      <div>
        <BrowserView>
          <div style={{ paddingTop: '50px', backgroundColor: '#FAFAFA' }}>
            <div style={{
              backgroundColor: '#FAFAFA',
              display: 'flex',
              paddingRight: '20px',
              paddingLeft: '20px'
            }}>
              <div style={{
                width: '70%',
                paddingRight: '5%',
                paddingLeft: '5%'
              }}>
                <h1>{this.state.header}</h1>

                <div style={{ maxWidth: "100%" }}>
                  {this.tableView()}
                </div>

              </div>
              <div style={{
                paddingTop: '50px',
                left: '77%',
                width: '20%',
                display: 'flex',
                flexDirection: 'column',
                position: 'fixed',
              }}>
                <Button
                  variant='outlined'
                  style={{
                    color: 'darkgreen',
                    marginBottom: '3px'
                  }}
                  onClick={this.Generate.bind(this)}
                >Generate</Button>
                <Button
                  variant='outlined'
                  style={{
                    color: 'darkgreen',
                    marginBottom: '3px'
                  }}
                  onClick={this.Convert.bind(this)}
                >Convert</Button><Button
                  variant='outlined'
                  style={{
                    color: 'darkgreen',
                    marginBottom: '3px'
                  }}
                  onClick={this.Ship.bind(this)}
                >Ship</Button><Button
                  variant='outlined'
                  style={{
                    color: 'darkgreen',
                    marginBottom: '3px'
                  }}
                  onClick={this.Receive.bind(this)}
                >Receive</Button><Button
                  variant='outlined'
                  style={{
                    color: 'darkgreen',
                    marginBottom: '3px'
                  }}
                  onClick={this.Plant.bind(this)}
                >Plant</Button>
                <Button
                  variant='outlined'
                  style={{
                    color: 'darkgreen',
                    marginBottom: '3px'
                  }}
                  onClick={this.Harvest.bind(this)}
                >Harvest</Button>
                <Button
                  variant='outlined'
                  style={{
                    color: 'darkgreen',
                    marginBottom: '3px'
                  }}
                  onClick={this.Harvest.bind(this)}
                >Import</Button>
                <Button
                  variant='outlined'
                  style={{
                    color: 'darkgreen',
                    marginBottom: '3px'
                  }}
                  onClick={this.Harvest.bind(this)}
                >Export</Button>
                <Button
                  variant='outlined'
                  style={{
                    color: 'darkgreen',
                    marginBottom: '3px'
                  }}
                  onClick={this.Harvest.bind(this)}
                >Register Strand</Button>
                <Button
                  variant='outlined'
                  style={{
                    color: 'darkgreen',
                    marginBottom: '3px'
                  }}
                  onClick={this.Harvest.bind(this)}
                >Delete Strands</Button>
                <Button
                  variant='outlined'
                  style={{
                    color: 'darkgreen',
                    marginBottom: '3px'
                  }}
                  onClick={this.Harvest.bind(this)}
                >Split</Button>
                <Button
                  variant='outlined'
                  style={{
                    color: 'darkgreen',
                    marginBottom: '3px'
                  }}
                  onClick={this.Harvest.bind(this)}
                >Combine</Button>

              </div>
            </div>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Tabs value={this.state.value} onChange={this.handleChange.bind(this)} fullWidth style={{
                backgroundColor: '#FAFAFA',
              }}>
                <Tab value="one" label="Product"></Tab>
                <Tab value="two" label="Strand"></Tab>
                <Tab value="three" label="Plot"></Tab>
              </Tabs>
            </div>
            {this.state.value === 'one' && <this.TabContainer>{this.productView()}</this.TabContainer>}
            {this.state.value === 'two' && <this.TabContainer>{this.strandView()}</this.TabContainer>}
            {this.state.value === 'three' && <this.TabContainer>{this.plotView()}</this.TabContainer>}
          </div>
        </BrowserView>
        <MobileView>
          <h1> This is rendered only on mobile </h1>
        </MobileView>
      </div>
      //   )}
      // </AuthUserContext.Consumer>
    );
  }
}



const condition = authUser => !!authUser;

export default compose(
  withEmailVerification,
  withAuthorization(condition),
)(HomePage);
